export const version  = 'v2'
export const WOKB = process.env.BUILD_ENV === 'test' ? '0xCA8aAceEC5Db1e91B9Ed3a344bA026c4a2B3ebF6' : '0xe538905cf8410324e03a5a23c1c177a474d59b2b'    // 定义 Uniswap V3 支持的费率
export const V3_FEE_TIERS = [100, 500, 3000, 10000];
export const stHskDel = '0x2ea2f4cbd74840f4ac6c65887ca2986c715d7193'
